import { Model } from 'ngx-super-model';

import { UserDTO } from '../interfaces/user.dto';
import { UserInfo } from './user-info.model';

export class User extends Model<UserDTO> {
  username = '';
  permissions: string[] = [];
  roles: string[] = [];
  user_info = new UserInfo();

  hasRoles(roles: string[]) {
    return this.roles.every(function (val) {
      return roles.indexOf(val) !== -1;
    });
  }

  override loadModel(input: UserDTO): this {
    super.loadModel(input);
    this.user_info = new UserInfo().loadModel(input.user_info);
    return this;
  }
}
